module.exports = __webpack_public_path__ + "static/media/left-barrier.e0f89871.svg";